import { createIcon } from './Icon'

// Do not modify this file as it was auto-generated by update-icons.mjs
export default createIcon(
  'Arrow3UpIcon',
  'arrow-3-up',
  'M656.773 444.324c19.994-19.999 52.413-19.999 72.407 0 19.994 19.993 19.994 52.41 0 72.406l-162.918 162.917c-29.993 29.992-78.62 29.992-108.612 0l-162.917-162.917c-19.995-19.995-19.995-52.413 0-72.406 19.995-19.999 52.413-19.999 72.408 0l95.43 95.428v-298.333c0-28.273 22.923-51.2 51.202-51.2s51.2 22.927 51.2 51.2v294.704l91.802-91.799z',
)
